import {
  COUPON_ALL,
  COUPON_GET,
  COUPON_DEL,
  COUPON_PUT,
  COUPON_POST,
  COUPON_LOADING,
  COUPON_ERROR,
} from '../../actions/types';

const initialState = {
  coupon: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case COUPON_LOADING:
      return { isLoading: true, isCompleted: true };
    case COUPON_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case COUPON_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case COUPON_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case COUPON_POST:
      return { isLoading: false, isCompleted: true };
    case COUPON_PUT:
      return { isLoading: false, isCompleted: true };
    case COUPON_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
